
import * as AuthenticationUtils from "./AuthenticationUtils";
import {CHANNEL_ID_LIST} from "../../components/Constants/ChannelConstant";
//channel ID=6046269145d0b54da48edf5e on .net
//channel ID=5dfcf21894e80144c1777058 on .com


export function getChannelId(serverUrl) {
    let channelId = "";
    if (
        AuthenticationUtils.isPointComServer(serverUrl) ||
        AuthenticationUtils.isPointComCnServer(serverUrl) ||
        AuthenticationUtils.isPointHealthServer(serverUrl)
    ) {
        channelId = CHANNEL_ID_LIST.COM;
    } else if (
        AuthenticationUtils.isPointNetServer(serverUrl) ||
        AuthenticationUtils.isPointCpaasServer(serverUrl) ||
        AuthenticationUtils.isPointOrgServer(serverUrl)
    ) {
        channelId = CHANNEL_ID_LIST.NET;
    }

    return channelId;
}